import React, { useState } from 'react';
import { Parallax } from 'rc-scroll-anim';
import { Slider } from 'antd';
import heroVideo from '../../videos/marketingProOverviewHeroVideo.mp4';
import mutedBtn from '../../images/volume-muted.svg';
import unmutedBtn from '../../images/volume-unmuted.svg';
import videoThumbnail from '../../images/marketing-pro-video-thumbnail.png';
import useBreakpoint from 'utils/useBreakpoint';

import { Container, UnMuteToolTip, VideoContainer } from './styles';

const MarketingProHeroHTML5Video = () => {
  const [playingVideo, setPlayingVideo] = useState(false);
  const [isMuted, toggleIsMuted] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [sliderValue, setSliderValue] = useState(null);
  const [prevSliderValue, setPrevSliderValue] = useState(null);
  const [initialUnMute, setInitialUnMute] = useState(false);
  const breakpoint = useBreakpoint();
  const isMobile = ['xs', 'sm'].includes(breakpoint?.breakpoint);

  const loadVideo = () => {
    setVideoLoaded(true);
  };

  const playVideo = () => {
    setPlayingVideo(true);
    const video = document.getElementById('video');
    if (video) video.play();
  };

  const stopVideo = () => {
    const video = document.getElementById('video');
    if (video) {
      video.pause();
      toggleMuted(true);
      video.muted = true;
    }
  };

  const toggleMuted = mute => {
    const video = document.getElementById('video');
    mute ? toggleIsMuted(true) : toggleIsMuted(!isMuted);

    if (isMuted || mute) {
      setPrevSliderValue(sliderValue);
      setSliderValue(0);
    } else {
      setSliderValue(prevSliderValue);
    }

    if (!mute && !initialUnMute) {
      video.muted = false;
      video.volume = 0.5;
      setInitialUnMute(true);
      setPrevSliderValue(50);
      setSliderValue(50);
    } else {
      video.muted = isMuted;
    }
  };

  const onSliderChange = value => {
    const video = document.getElementById('video');
    const volumeLevel = value / 100;
    video.volume = volumeLevel;
    video.muted = false;
    toggleIsMuted(true);
    setSliderValue(value);
  };

  return (
    <Container tooltip={initialUnMute}>
      {!isMobile && (
        <Parallax
          animation={[
            { playScale: [0.2, 1], onStart: () => loadVideo() },
            { width: '100%', playScale: [-0.7, 0], onStart: () => playVideo() },
            { playScale: [0.75, 1], onStart: () => stopVideo(), onStartBack: () => playVideo() },
          ]}
          style={{ width: '60%', position: 'relative' }}
        >
          {!isMobile && (
            <div className="marketing-pro-hero--volume-controls">
              {initialUnMute && (
                <Slider
                  vertical
                  value={sliderValue}
                  onChange={onSliderChange}
                  defaultValue={50}
                  tipFormatter={null}
                  className="marketing-pro-hero--video-slider"
                />
              )}
              <UnMuteToolTip hide={initialUnMute}>Tap to Unmute</UnMuteToolTip>
              <img
                src={isMuted ? unmutedBtn : mutedBtn}
                className="mute-unmute-btn"
                onClick={() => toggleMuted()}
              />
            </div>
          )}
          <VideoContainer playingVideo={playingVideo}>
            {videoLoaded && (
              <video
                playsInline
                loop
                muted
                width="100%"
                id="video"
                style={{ display: playingVideo ? 'block' : 'none' }}
              >
                <source src={heroVideo} type="video/mp4" />
                Your browser does not support HTML video.
              </video>
            )}
          </VideoContainer>
        </Parallax>
      )}
      {isMobile && (
        <video playsinline loop controls muted width="100%" id="video" poster={videoThumbnail}>
          <source src={heroVideo} type="video/mp4" />
          Your browser does not support HTML video.
        </video>
      )}
    </Container>
  );
};

export default MarketingProHeroHTML5Video;
